import 'react-toastify/dist/ReactToastify.css';

// import axios from 'axios';
import { Provider } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from 'styled-components';

// import authApis from './APIs/auth';
import RootProvider from './context/RootProvider';
import PageTitle from './designComponents/PageTitle';
import ScrollToTop from './designComponents/ScrollToTop';
import Store from './store';
import GlobalStyle from './style/globalStyle';
import theme from './theme';
// import { requestAPI } from './utils';

function App() {
  // axios.interceptors.response.use(
  //   (response) => {
  //     // Handle successful responses
  //     return response;
  //   },
  //   async (error) => {
  //     const originalRequest = error.config;
  //     console.log({ originalRequest });
  //     if (error.response.status === 401 && !originalRequest._retry) {
  //       originalRequest._retry = true;
  //       const refreshToken = localStorage.getItem(
  //         escConstants.LOCAL_STORAGE_KEY.refreshKey
  //       );

  //       if (!refreshToken) {
  //         return error;
  //       }
  //       try {
  //         const refreshResponse = await requestAPI(
  //           authApis.refreshToken({
  //             refreshToken,
  //           })
  //         );
  //         const newAccessToken = refreshResponse?.token;
  //         // Update the access token in localStorage
  //         localStorage.setItem(
  //           escConstants.LOCAL_STORAGE_KEY.accessKey,
  //           newAccessToken
  //         );
  //         // const newRefreshToken = refreshResponse?.refreshToken;

  //         // localStorage.setItem(
  //         //   escConstants.LOCAL_STORAGE_KEY.refreshKey,
  //         //   newRefreshToken
  //         // );

  //         axios.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`;
  //         axios.defaults.headers.Authorization = `Bearer ${newAccessToken}`;

  //         // Retry the original request with the new access token
  //         originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
  //         return await axios(originalRequest);
  //       } catch (refreshError) {
  //         // Handle refresh token failure (e.g., logout user, redirect to login)
  //         console.error('Failed to refresh token:', refreshError);
  //         // Perform logout action or redirect to login page
  //       }
  //     }

  //     // Handle other error cases
  //     return Promise.reject(error);
  //   }
  // );

  return (
    <RootProvider>
      <Provider store={Store.store}>
        <ThemeProvider theme={theme}>
          <ScrollToTop />
          <PageTitle />
          <GlobalStyle />
          <Outlet />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnHover
            theme="light"
            style={{ zIndex: theme.zIndices.toast }}
            progressStyle={{ background: theme.colors.primary }}
          />
        </ThemeProvider>
      </Provider>
    </RootProvider>
  );
}

export default App;
